export default __webpack_public_path__ + "static/media/ologo.ab52532f.png";